import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25f8f1b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "side-bottle" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

import { type ComputedRef, inject } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const images = inject<ComputedRef<Record<string, string>>>('images')!;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "bottle-45deg",
      src: _unref(images)['bottle-45deg']
    }, null, 8, _hoisted_2),
    _createElementVNode("img", {
      class: "bottle-135deg-1-line",
      src: _unref(images)['bottle-135deg-1-line']
    }, null, 8, _hoisted_3)
  ]))
}
}

})